var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hiv-quiz',{attrs:{"question":"Pre-exposure prophylaxis (or PrEP) is when people at high risk of HIV take HIV medicines to lower their chances of getting infected.","answer":true}})}
var staticRenderFns = []

export { render, staticRenderFns }